<template>
  <SloLoader :loading="loading" size="xl">
    <div
      v-if="onlineDistributors"
      v-for="onlineDistributor in onlineDistributors"
      class="distributor flex items-center justify-between gap-md mx-md md:mx-lg"
    >
      <figure>
        <img
          v-if="onlineDistributor.logo"
          width="100"
          :src="onlineDistributor?.logo?.url"
          :alt="onlineDistributor?.logo?.alt"
        />
      </figure>
      <div>
        <SloButton
          :href="onlineDistributor.website"
          target="_blank"
          fill="solid"
          class="flex items-center gap-xs"
        >
          {{ 'Visit Site' | t }}
          <SloIcon name="SquareArrowUpRight" />
        </SloButton>
      </div>
    </div>
    <div v-else>
      {{ 'No online distributors found.' | t }}
    </div>
  </SloLoader>
</template>

<script>
import t from '../../js/main/i18n';
import SloButton from './SloButton.vue';
import SloIcon from './SloIcon.vue';
import SloLoader from './SloLoader.vue';

export default {
  name: 'SloOnlineDistributors',
  components: {
    SloLoader,
    SloIcon,
    SloButton
  },
  filters: {
    t
  },
  data() {
    return {
      loading: true,
      onlineDistributors: []
    };
  },
  created() {
    fetch('/api/v1/supply-chain-filter?types=national_distributor&_format=json')
      .then(response => response.json())
      .then(data => {
        this.loading = false;
        this.onlineDistributors = data;
      });
  }
};
</script>
